import request from '@/utils/request'

export default {
  login (data) {
    return request({
      url: `/auth/local`,
      method: 'post',
      data: data
    })
  },
  getForm (data) {
    return request({
      url: `/forms`,
      method: 'get',
      params: {
        _limit: -1
      }
    })
  },
  updateFormStatus (id, data) {
    let status = null
    if (data.status === 'solve') {
      status = 'unread'
    } else {
      status = 'solve'
    }
    return request({
      url: `/forms/${id}`,
      method: 'put',
      data: {
        ...data,
        status: status
      }
    })
  }
}
